/**
 * @module impressionable/__CONSTANTS
 * @private
 * @since 2.0.0
 */

/**
 * Throttle events like scroll and resize between DOM querying
 * @type {Number}
 */
export const COLLECT_DELAY = 200;

/**
 * custom event that triggers impression collecting
 * @type {String}
 */
export const CUSTOM_EVENT = 'collect-impressions';

/**
 * Throttle event report dispatches
 * @type {Number}
 */
export const DISPATCH_DELAY = 500;

/**
 * @typedef LISTENER_OPTIONS @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @type {Object}
 * @property {Boolean} capture Dispatch to listener before child event targets
 * @property {Boolean} once    Listener should be removed once invoked
 * @property {Boolean} passive Listener can not call preventDefault()
 */

/**
 * LISTENER_OPTIONS
 * @type {LISTENER_OPTIONS}
 */
export const LISTENER_OPTIONS = {
    capture: false,
    once: false,
    passive: false
};

/**
 * Impressionable's storage key
 * @type {String}
 */
export const STORAGE_KEY = 'impressionable_events';

/**
 * DOM attribute for "impressed" elements
 * @type {String}
 */
export const VIEWED_ATTRIBUTE = 'data-impression-collected';

/**
 * Window events we want to listen to
 * @private
 * @type {String[]}
 */
export const WINDOW_LISTENERS = [
    'load',
    'resize',
    'scroll',
    'touchmove'
];
